export default "__VITE_ASSET__DhF3_37y__"